<template>
  <div
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <div class="mb-2 mt-2 pt-3">
      <button-search
        ref="buttonSearch"
        placeholder="搜索邮箱"
        @search="searchEvent"
        :showGj="false"
      >
        <!-- 左边 -->
        <template #left>
          <!-- <span class="mr-4">总充值：<el-tag>{{cz_money}} 元</el-tag></span>
					<span class="mr-4">总提现：<el-tag>{{tx_money}} 元</el-tag></span> -->
          <!-- <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加背景</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->
        </template>

        <!-- 高级搜索 1-->
        <template #from>
          <el-form inline ref="form" :model="from" label-width="100px">
            <el-form-item label="用户ID" class="mb-0">
              <el-input
                size="small"
                v-model="from.id"
                placeholder="搜索ID"
              ></el-input>
            </el-form-item>
            <el-form-item label="ArenaID" class="mb-0">
              <el-input
                size="small"
                v-model="from.u_id"
                placeholder="搜索ArenaID"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" class="mb-0">
              <el-input
                size="small"
                v-model="from.username"
                placeholder="搜索邮箱"
              ></el-input>
            </el-form-item>

            <el-form-item label="状态" class="mb-0">
              <el-select
                v-model="from.type"
                size="small"
                placeholder="请选择查看类型"
              >
                <el-option label="全部" :value="-1"></el-option>
                <el-option label="充值" :value="3"></el-option>
                <el-option label="提现" :value="4"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="时间" size="small" class="mb-0">
              <el-date-picker
                v-model="from.time"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="mb-0">
              <el-button type="info" @click="searchEvent" size="small"
                >搜索
              </el-button>
              <el-button size="small" @click="clearSearch"
                >清空筛选条件</el-button
              >
            </el-form-item>
          </el-form>
        </template>
      </button-search>
    </div>

    <!-- 表格 -->
    <div class="mt-3 pt-2">
      <el-table
        :data="tableData"
        @sort-change="sortChange"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
        <el-table-column
          fixed
          align="center"
          type="index"
          label="排序"
          width="50"
        >
        </el-table-column>
        <el-table-column
          align="center"
          min-width="120"
          prop="card_number"
          label="主播信息"
        >
          <template slot-scope="v">
            <el-avatar :src="v.row.user.head"></el-avatar>
            <!-- <div><span class="text-warning">ID：</span>{{v.row.user_id}}</div> -->
            <!-- <div><span class="text-warning">昵称：</span>{{v.row.user.nickname}}</div> -->
            <div>{{ v.row.user.nickname }}</div>
            <div><span class="text-warning">ID：</span>{{ v.row.user.id }}</div>

            <div>
              <span class="text-warning">账号：</span>{{ v.row.user.username }}
            </div>
            <!-- 						<div><span class="text-warning">房间ID：</span>{{v.row.user.groupId}}</div>
 -->
          </template>
        </el-table-column>

        <el-table-column align="center" prop="name" label="赛程类型">
          <template slot-scope="v">
            <span v-if="v.row.type_id == 1">足球</span>
            <span v-if="v.row.type_id == 2">篮球</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="com_name" label="联赛分类名称">
        </el-table-column>
        <el-table-column align="center" prop="match_name" label="赛程名称">
        </el-table-column>
        <el-table-column
          align="center"
          sortable="custom"
          prop="now_num"
          label="直播间当前人数"
        >
          <template slot-scope="v">
            <div v-for="(item, index) in v.row.now_num.other" :key="index">
              <span>{{ item.name ? item.name : "未知" }}：</span>
              <span>{{ item.total }}</span>
            </div>
            <p>
              <span v-if="v.row.now_num.total_count != 0">总计：</span
              ><span>{{ v.row.now_num.total_num }}</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          sortable="custom"
          prop="total_num"
          label="直播间总人数"
        >
          <template slot-scope="v">
            <div v-for="(item, index) in v.row.total_num.other" :key="index">
              <span>{{ item.name ? item.name : "未知" }}：</span>
              <span>{{ item.total }}</span>
            </div>
            <p>
              <span v-if="v.row.total_num.total_count != 0">总计：</span
              ><span>{{ v.row.total_num.total_num }}</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column
          sortable="custom"
          align="center"
          prop="play_time"
          width="200"
          label="开赛时间"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          align="center"
          prop="match_time"
          width="200"
          label="开播时间"
        >
        </el-table-column>
      </el-table>
    </div>

    <div style="height: 60px"></div>
    <el-footer
      class="d-flex border-top bg-white align-items-center px-0 position-fixed"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"
    >
      <!-- 底部 -->

      <div style="flex: 1" class="px-2">
        <el-pagination
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-footer>

    <el-dialog title="拒绝通过" :visible.sync="createModel" top="5vh">
      <!-- 表单内容 -->
      <el-form :rules="rules" ref="form" :model="form" label-width="100px">
        <el-form-item label="拒绝原因" prop="remark">
          <el-input
            v-model="form.remark"
            placeholder="拒绝原因"
            type="textarea"
            :rows="5"
            clearable
            size="small"
            style="width: 90%"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="createModel = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
import buttonSearch from "@/components/common/button-search.vue";
export default {
  components: {
    buttonSearch,
  },
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      createModel: false,
      editIndex: -1,
      //搜索数据
      from: {
        id: "",
        u_id: "",
        username: "",
        type: -1,
        time: [],
      },
      model_title: "Host",
      auth_val: "Mtlog",
      preUrl: "data/hostList", //列表地址

      tableData: [],
      form: {
        id: 0,
        remark: "",
      },
      prop: "play_time",
      sort: "descending",
      rules: {
        remark: [
          {
            required: true,
            message: "请输入拒绝原因",
            trigger: "blur",
          },
        ],
      },
      rule_list: [],
      check_img_list: [],
      cz_money: 0,
      tx_money: 0,
    };
  },
  watch: {
    activeName(e) {
      console.log(e);
    },
  },
  created() {
    //this.commonList('rule');
  },
  methods: {
    sortChange(column) {
      this.prop = column.prop;
      this.sort = column.order;
      this.getList();
    },
    //提交
    submit() {
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },

    is_ok(item) {
      this.$confirm("确定通过此条申请吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.layout.loading = true;
        this.api
          .post(
            "/apply/addKyc",
            {
              id: item.id,
              type: 1,
              remark: "",
            },
            
          )
          .then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getList();
            this.layout.loading = false;
          })
          .catch((err) => {
            this.layout.loading = false;
          });
      });
    },

    // 打开模态框
    openModel(e, type) {
      // 修改
      this.form = {
        id: e.id,
        remark: "",
        type: 2,
      };
      this.editIndex = e.id;
      // 打开dialog
      this.createModel = true;
    },

    //公共列表

    //前往修改页面
    editItem(obj) {
      this.$router.push({
        name: "set_manager_rule",
        query: {
          item: obj,
        },
      });
    },
    getListResult(e) {
      this.tableData = e.list;
      this.cz_money = e.cz_money;
      this.tx_money = e.tx_money;
      console.log(this.tableData);
      this.check_img_list = e.list.map((item) => {
        return item.head;
      });
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        id: "",
        u_id: "",
        username: "",
        type: -1,
        time: [],
      };

      this.$refs.buttonSearch.closeSuperSearch();
      this.search = "";
      this.getList();
    },
  },
};
</script>

<style>
</style>
